import {ChangeDetectorRef, Component, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {FlatpickrOptions} from "ng2-flatpickr";
import feather from "feather-icons";
import {HeaderService} from "../../../../../services/header/header.service";
import {Router} from "@angular/router";
import {ProjetService} from "../../../../../services/projet.service";
import {ToastrService} from "ngx-toastr";
import {AjoutProjetComponent} from "../../../../parametre/project-parametre/ajout-projet/ajout-projet.component";
import {Client} from "../../../../../models/client";
import {Product} from "../../../../../models/Product";
import {ClientService} from "../../../../../services/Client/client.service";
import {ProductsService} from "../../../../../services/products/products.service";
import {WarehouseService} from "../../../../../services/warehouse/warehouse.service";


@Component({
    selector: 'app-add-inventaire',
    templateUrl: './add-inventaire.component.html',
    styleUrls: ['./add-inventaire.component.scss']
})
export class AddInventaireComponent implements OnInit {

    @ViewChild('ajout') ajoutComponent!: AjoutProjetComponent;
   @Input() bonTransfert = false;
    @Input() isInventory = false;
   @Input() entrpotInit = false;

    file: string = environment.file_url;
    items: any[] = [];
    projects: any[] = [];
    tvaSummary: any[] = [];
    predefinedProducts: any[] = [
        {
            name: 'Chemise zara',
            priceHT: 100,
            tva: '19',
            logo: '../../../../../../../../../assets/images/logo/image.png',
            quantity: 0
        },
        {
            name: 'Baskets nike',
            priceHT: 200,
            tva: '7',
            logo: '../../../../../../../../../assets/images/logo/image.png',
            quantity: 3
        }
    ];
    isTitleVisible = true;

    isDateVisible = true;
    isProjectVisible = true;
    isEntrepotVisible = true;
    isNoteVisible = true;
    isSettingsPanelOpen = false;
    activeTab: 'document' | 'taxe' | 'devise' = 'document';
    clients: Client[] = [];

    products : Product [] = [];

    taxSummary = [
        {tva: 19, base: 200, montant: 38}
    ];

    totals = {
        totalHT: 0,
        totalTVA: 0,
        totalTTC: 0,
        timbreFiscal: 0.6,
        netAPayer: 0.6
    };

    currencies = [
        {code: 'USD', name: 'Dollar des États-Unis', flag: 'US', rate: '0.33 $US'},
        {code: 'BRL', name: 'Real Brésilien', flag: 'BR', rate: '0.33 $US'},
        {code: '$6.48k', name: 'India', flag: 'IN', rate: '0.33 $US'},
        {code: '$5.12k', name: 'Australia', flag: 'AU', rate: '0.33 $US'},
        {code: '$4.45k', name: 'France', flag: 'FR', rate: '0.33 $US'},
        {code: '$3.90k', name: 'China', flag: 'CN', rate: '0.33 $US'}
    ];

    filteredCurrencies = [...this.currencies];
    currencySearch = '';

    selectedClient = '';
    selectedProject = '';
    selectedEntrepot = '';
    documentDate = '2025-04-15';
    note = '';
    documentLabel = 'devis';
    primaryColor = '#ffffffff';
    showColorPicker = false;
    taxSettings = {
        timbreFiscal: {enabled: true, amount: '0.600 TND'},
        timbreFiscalTaxe: {enabled: true, amount: '0.600 TND'}
    };

    documentSettings = {
        reference: true,
        quantite: true,
        unite: false,
        prixUnitaire: true,
        tva: true,
        remise: false,
        afficherMontantsTTC: true,
        afficherCodeBarres: true,
        afficherDateEcheance: false,
        afficherDateLivraison: false,
        afficherMontantTotal: false,
        afficherCoordonneesClients: false
    };

    dateFrequency = 'jours';
    dateValue = 1;

    public basicDateOptions: FlatpickrOptions = {
        defaultDate: new Date(),
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        minDate: 'today',
        allowInput: true,
        altInputClass: 'form-control flatpickr-input'
    };


    currentUser = JSON.parse(localStorage.getItem('currentUser'));

    clientId = this.currentUser?.id;
    stationId = this.currentUser?.stations?.[0]?.id;

    constructor(private toastr: ToastrService,
                private projetService: ProjetService,
                private cdr: ChangeDetectorRef,
                private headerService: HeaderService,
                private clientService: ClientService,
                private zone: NgZone,
                private productsService: ProductsService,
                private warehouseService: WarehouseService,
                private router: Router) {
    }

    ngOnInit(): void {

        this.loadProjects();
        this.loadClients();
        this.loadProducts();
        this.calculateTotals();
        this.filterCurrencies();
        this.getAllEntrepots();

        this.headerService.setConfig({

            title: this.isInventory ? 'Inventaire' : 'Bon de transfert',

            buttons: [
                {
                    label: 'Retour',
                    action: () => this.retour(),
                    type: 'primary'
                }
                ,
                {
                    label: 'Annuler',
                    action: () => this.retour(),
                    type: 'secondary'
                },
                {
                    label: 'Apercevoir',
                    action: () => this.goToApercu(),
                    type: 'primary'
                },
                {
                    label: 'Approuver',
                    action: () => this.approved(),
                    type: 'primary'
                }
            ]
        });
    }

    retour() {
        this.router.navigate(['/inventaire']);
    }

    approved() {
        this.router.navigate(['/inventaire/', 'validation']);

    }

    goToApercu() {
        this.router.navigate(['/inventaire/', 'apercu']);
    }

    ngAfterViewInit() {
        feather.replace();
    }

    incrementPaymentPeriod(): void {
        this.dateValue = (this.dateValue || 1) + 1;

    }

    decrementPaymentPeriod(): void {
        if (this.dateValue > 1) {
            this.dateValue -= 1;

        }
    }
    openAjoutModal() {
        this.ajoutComponent.projectData = null;
        this.ajoutComponent.openModal();
    }

    openSettingsPanel() {
        this.isSettingsPanelOpen = true;
        this.activeTab = 'document'; // Ensure default tab is set
        setTimeout(() => feather.replace(), 0); // Re-render icons after panel opens
    }

    closeSettingsPanel() {
        this.isSettingsPanelOpen = false;
    }

    setActiveTab(tab: 'document' | 'taxe' | 'devise') {
        console.log('setActiveTab:', tab);
        this.activeTab = tab;
        setTimeout(() => feather.replace(), 0); // Re-render icons after tab change
    }

    addClient() {
        console.log('addClient: Adding new client');
    }

    addProject() {
        console.log('addProject: Adding new project');
    }


  /*  addProduct() {
        this.products.push({
            designation: '',
            quantity: 1,
            prixHT: 0,
           // tva: 19,
            totalHT: 0
        });
        this.calculateTotals();
    }*/

    calculateTotals() {
     /*   this.totals.totalHT = this.products.reduce((sum, p) => sum + (p.quantity * p.prixHT), 0);
        this.totals.totalTVA = this.products.reduce((sum, p) => sum + ((p.quantity * p.prixHT) * p.tva / 100), 0);
        this.totals.totalTTC = this.totals.totalHT + this.totals.totalTVA;
        this.totals.netAPayer = this.totals.totalTTC + this.totals.timbreFiscal;

        this.taxSummary = [];
        const tvaRates = [...new Set(this.products.map(p => p.tva))];
        tvaRates.forEach(rate => {
            const base = this.products
                .filter(p => p.tva === rate)
                .reduce((sum, p) => sum + (p.quantity * p.prixHT), 0);
            this.taxSummary.push({tva: rate, base, montant: base * rate / 100});
        }); */
    }

    saveDevis() {
        console.log('saveDevis: Saving devis');
    }

    downloadDevis() {
        console.log('downloadDevis: Downloading devis');
    }

    shareDevis() {
        console.log('shareDevis: Sharing devis');
    }

    printDevis() {
        console.log('printDevis: Printing devis');
    }

    saveSettings() {
        console.log('saveSettings:', {
            primaryColor: this.primaryColor,
            taxSettings: this.taxSettings,
            documentSettings: this.documentSettings,
            documentLabel: this.documentLabel,
            dateFrequency: this.dateFrequency,
            dateValue: this.dateValue
        });
    }


    filterCurrencies() {

        if (!this.currencySearch) {
            this.filteredCurrencies = [...this.currencies];
        } else {
            const searchTerm = this.currencySearch.toLowerCase();
            this.filteredCurrencies = this.currencies.filter(currency =>
                currency.code.toLowerCase().includes(searchTerm) ||
                currency.name.toLowerCase().includes(searchTerm)
            );
        }
    }

    editCurrency(currency: any) {
        console.log('editCurrency:', currency);
    }

    addItems(type: 'code_bar' | 'product' | 'text' | 'heading' | 'separator' | 'subtotal') {
        switch (type) {
            case 'product':
                this.items.push({
                    type: 'product',
                    designation: '',
                    quantity: 0,
                    priceHT: 0,
                    tva: '0',
                    totalHT: 0
                });
                break;
            case 'text':
                this.items.push({
                    type: 'text',
                    content: ''
                });
                break;
            case 'heading':
                this.items.push({
                    type: 'heading',
                    content: ''
                });
                break;
            case 'separator':
                this.items.push({
                    type: 'separator'
                });
                break;
            case 'subtotal':
                const subTotal = this.calculateSubTotal();
                this.items.push({
                    type: 'subtotal',
                    subTotal
                });
                break;
        }
        this.calculateTotals();
        this.cdr.detectChanges();
    }


    calculateSubTotal(): number {
        const subTotal = this.items
            .filter(item => item.type === 'product' && item.designation)
            .reduce((sum, item) => sum + (item.totalHT || 0), 0);
        console.log('calculateSubTotal:', subTotal);
        return subTotal;
    }

    removeItem(index: number) {
        this.items.splice(index, 1);
        console.log('removeItem: Updated items:', this.items);
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    onProductSelect(index: number, value: string | Event) {
        const selectedProductName = typeof value === 'string' ? value : (value.target as HTMLSelectElement).value;
        console.log('onProductSelect: Index:', index, 'Selected:', selectedProductName);
        const product = this.predefinedProducts.find(p => p.name === selectedProductName);
        if (product) {
            this.items[index] = {
                ...this.items[index],
                designation: product.name,
                priceHT: product.priceHT,
                tva: product.tva,
                quantity: this.items[index].quantity || 1,
                totalHT: (this.items[index].quantity || 1) * product.priceHT
            };
        } else {
            this.items[index] = {
                ...this.items[index],
                designation: '',
                quantity: 0,
                priceHT: 0,
                tva: '0',
                totalHT: 0
            };
        }
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    handleImageError(event: Event) {
        console.error('Image load error:', event);
        const img = event.target as HTMLImageElement;
        img.src = '';
    }

    calculateTotal(index: number) {
        const item = this.items[index];
        if (item.type === 'product' && item.designation) {
            item.totalHT = (item.quantity || 0) * (item.priceHT || 0);
            console.log('calculateTotal: Item:', item);
            this.calculateTotals();
            this.cdr.detectChanges();
        }
    }

    customFields: { label: string, value: string }[] = [];

    addField() {
        this.customFields.push({
            label: '',
            value: ''
        });
    }

    removeField(index: number) {
        this.customFields.splice(index, 1);
    }

    isDateReadonly = false;
    isEntrepotReadonly = false;
    isProjectReadonly = false;
    isNoteReadonly = false;

    toggleReadonly(field: string) {
        if (field === 'date') {
            this.isDateReadonly = !this.isDateReadonly;
        } else if (field === 'entrepot') {
            this.isEntrepotReadonly = !this.isEntrepotReadonly;
        } else if (field === 'project') {
            this.isProjectReadonly = !this.isProjectReadonly;
        } else if (field === 'note') {
            this.isNoteReadonly = !this.isNoteReadonly;
        }
    }

    loadProjects(): void {
        this.projetService.getProjectsByIdStation(this.stationId).subscribe({
            next: (projects) => {
                this.projects = projects;
                // console.log(projects);
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des projets');
            }
        });
    }

    onProjectSaved() {
        this.loadProjects();
    }
    isLoadingClients = false;
    loadClients(): void {
        if (!this.stationId) {
            console.error('No station_id found in currentUser:', this.currentUser);
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingClients = false;
            this.clients = [];
            this.cdr.detectChanges();
            return;
        }

        console.log('loadClients: Using station_id:', this.stationId);
        this.isLoadingClients = true;
        this.clientService.getActiveClient(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.zone.run(() => {
                    this.clients = response.data || [];
                    this.isLoadingClients = false;
                    console.log('Clients loaded:', this.clients);
                    this.cdr.detectChanges();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingClients = false;
                    this.clients = [];
                    this.toastr.error('Erreur lors du chargement des clients.', 'Erreur');
                    console.error('Error loading clients:', err);
                    this.cdr.detectChanges();
                });
            }
        });
    }
    isLoadingProducts = false;
    loadProducts(): void {
        if (!this.stationId) {
            console.error('No station_id found in currentUser:', this.currentUser);
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingProducts = false;
            this.products = [];
            this.cdr.markForCheck();
            return;
        }

        console.log('loadProducts: Using station_id:', this.stationId);
        this.isLoadingProducts = true;
        this.productsService.getActiveProductsByStationId(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.zone.run(() => {
                    this.products = (response.data || []).map((apiProduct: any) => ({
                        ...apiProduct,
                        prix_unitaires: parseFloat(apiProduct.prix_unitaires) || 0,
                        liste_prix: apiProduct.liste_prix.length > 0 ? apiProduct.liste_prix[0] : null,
                        informations_logistique: apiProduct.informations_logistique || []
                    }));
                    this.isLoadingProducts = false;
                    console.log('Products loaded:', this.products);
                    this.cdr.markForCheck();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingProducts = false;
                    this.products = [];
                    this.toastr.error('Erreur lors du chargement des produits.', 'Erreur');
                    console.error('Error loading products:', err);
                    this.cdr.markForCheck();
                });
            }
        });
    }

    allEntrepot: any []

    getAllEntrepots(): void {
        this.warehouseService.getAllWarehouses(this.clientId, this.stationId).subscribe({
            next: (warehouses) => {
                this.allEntrepot = warehouses;

            },
            error: (err) => console.error(err)
        });

    }
}
